import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="container">

        <h2 className="footer-title">
          Kashi Lighting Design and Consultancy
        </h2>

        <p className="footer-description">
          Creating elegant indoor and outdoor lighting experiences through
          innovative design, consultancy and premium solutions.
        </p>

        <div className="footer-info">

          <div className="footer-item">
            📍 Nesco, WeWork, Goregaon East, Mumbai
          </div>

          <div className="footer-item">
            📞 +91 98697 95151
          </div>

          <div className="footer-item">
            ✉️ info@kashilighting.com
          </div>

          <div className="footer-item">
            🕘 Mon - Sat | 9:00 AM - 6:30 PM
          </div>

        </div>

        <div className="footer-divider"></div>

        <p className="footer-copy">
          © {new Date().getFullYear()} Kashi Lighting Design and Consultancy.
          All Rights Reserved.
        </p>

        <p className="footer-credit">
          Designed by by Kashi Lighting
        </p>

      </div>

      <button
        className="scroll-top-btn"
        onClick={() =>
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          })
        }
      >
        ↑
      </button>
    </footer>
  );
}

export default Footer;